/* globals jQuery, IHPME, google */
/* eslint-disable @wordpress/no-global-active-element */

/**
 * External dependencies
 */
import CliboardJS from 'clipboard';

/**
 * Internal dependencies
 */
import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';
import setupTabs from './theme/tabs';
import setupAccordions from './theme/accordions';
import setupModals from './theme/modals';
import setupCarousels from './theme/carousels';
import setupDatePickers from './theme/datepicker';
import setupDropdowns from './theme/dropdown';
import setupDirectoryModules from './theme/ajax-directory';
import setupFilterableListings from './theme/filterable-listing';
import setupDiscoverModules from './theme/discover-modules';
import setupShareButtons from './theme/share-button';
//import mapStyles from './shared/mapstyle.json';

jQuery( $ => {
	const $body = $( 'body' );
	const $window = $( window );

	// =========================
	// ! Flag Interaction Method
	// =========================

	document.addEventListener( 'mousemove', () => document.body.classList.add( 'using-mouse' ) );
	document.addEventListener( 'touchstart', () => document.body.classList.add( 'using-mouse' ) );
	document.addEventListener( 'keydown', () => document.body.classList.remove( 'using-mouse' ) );

	// =========================
	// ! External Link Mandate
	// =========================

	document.querySelectorAll( 'a[href^="http"]' ).forEach( anchor => {
		if ( ! anchor.target && ! anchor.href.startsWith( window.location.origin ) ) {
			anchor.setAttribute( 'target', '_blank' );
			anchor.setAttribute( 'rel', 'noreferrer noopener' );
		}
	} );

	// =========================
	// ! Basic Toggles
	// =========================

	$body.on( 'click', '.js-toggle', function( event ) {
		const target = determineTarget( this );
		if ( target ) {
			event.preventDefault();
			const isOpen = toggleElement( target, null, 'focus' );

			// For global styling that might be needed
			$body.toggleClass( `show-${ target.id }`, isOpen );
		}
	} );

	$( '.js-close' ).on( 'click', function() {
		toggleElement( this.closest( '[aria-hidden="false"]' ), false );
	} );

	// =========================
	// ! Modals
	// =========================

	// Add classes to modals automatically
	$( '.ihpme-modal' ).addClass( 'js-modal' );
	$( '.ihpme-modal__close' ).addClass( 'js-modal-close' );
	$( '.ihpme-modal__frame' ).addClass( 'js-modal-backdrop' );

	setupModals();

	// =========================
	// ! Tab Set
	// =========================

	// Add classes to tab/tabset blocks automatically
	$( '.ihpme-tab-set' ).addClass( 'js-tab-set' );
	$( '.ihpme-tab-set__nav-item' ).addClass( 'js-tab' );
	$( '.ihpme-tab-panel' ).addClass( 'js-tab-panel' );

	// Mark first tab as auto-open accordion
	$( '.ihpme-tab-set' ).each( function() {
		$( this ).find( '.ihpme-tab-header__toggle' ).first().addClass( 'auto-open' );

		// Animate to the target tab
		const $nav = $( this ).find( '.ihpme-tab-set__nav' );
		const $navItems = $( this ).find( '.ihpme-tab-set__nav-item' );

		$nav.css( '--current-tab-offset', $navItems.first().position().left + 'px' );
		$nav.css( '--current-tab-width', $navItems.first().width() + 'px' );

		$navItems.on( 'click', function() {
			const toggle = $( this );

			$nav.css( '--current-tab-offset', $( toggle ).position().left + 'px' );
			$nav.css( '--current-tab-width', $( toggle ).width() + 'px' );
		} );
	} );

	setupTabs();

	// =========================
	// ! Accordion
	// =========================

	// Add classes to accordion blocks automatically
	$( '.ihpme-accordion-group, .ihpme-tab-set' ).addClass( 'js-accordion-group' );
	$( '.ihpme-accordion__toggle, .ihpme-tab-header__toggle' ).addClass( 'js-accordion-toggle' );
	$( '.ihpme-accordion__content, .ihpme-tab-panel' ).addClass( 'js-accordion-content' );

	setupAccordions( IHPME.accordionEndpoints || [] );

	// =========================
	// ! Gallery Carousels
	// =========================

	// Prep carousel galleries for functionality
	$( '.ihpme-carousel' ).each( function() {
		$( this ).addClass( 'js-carousel' );
		$( this ).find( '.ihpme-carousel__slides' ).addClass( 'js-carousel-track' )
			.children().addClass( 'js-carousel-slide' );
		$( this ).find( '.ihpme-carousel__pagination' ).addClass( 'js-carousel-pagination' );
	} );

	setupCarousels( { animate: true } );

	// =========================
	// ! Hidden Target Handling
	// =========================

	function handleHiddenTarget( event ) {
		if ( window.location.hash.length < 2 ) {
			return;
		}

		// Get the target element
		const target = document.getElementById( window.location.hash.substring( 1 ) );
		if ( ! target ) {
			return;
		}

		// See if it's within a hidden container
		const container = target.closest( '[id][aria-hidden="true"]' );
		if ( ! container ) {
			return;
		}

		// Find the control for the container
		const control = document.querySelector( `[aria-controls=${ container.id }]` );
		if ( ! control ) {
			return;
		}

		// Prevent automatic scolling
		if ( event ) {
			event.preventDefault();
		}

		// Open the container and focus
		control.click();
		target.scrollIntoView();
	}

	window.addEventListener( 'hashchange', handleHiddenTarget );
	handleHiddenTarget();

	// =========================
	// ! Item/Image Rotation
	// =========================

	$( '.js-item-rotation' ).each( function() {
		let enabled = true;
		const $items = $( this ).children();
		const $count = $items.length;
		const delay = 3000;
		let currentItem = 0;
		$items.first().addClass( 'is-current' );

		const mediaQuery = window.matchMedia( '(prefers-reduced-motion: reduce)' );
		function checkReducedMotion() {
			enabled = ! mediaQuery.matches;
		}

		checkReducedMotion();
		if ( typeof mediaQuery.addEventListener === 'undefined' ) {
			mediaQuery.addListener( () => checkReducedMotion );
		} else {
			mediaQuery.addEventListener( 'change', checkReducedMotion );
		}

		function setItem( index ) {
			$items.removeClass( 'is-current' );
			$items.eq( index ).addClass( 'is-current' );
		}
		function slide() {
			if ( ! enabled ) {
				return;
			}

			currentItem = currentItem < $count - 1 ? currentItem + 1 : 0;
			setItem( currentItem );
			setTimeout( slide, delay );
		}

		if ( enabled ) {
			setTimeout( slide, delay );
		}
	} );

	// =========================
	// ! Wizard Nav Menu
	// =========================

	document.querySelectorAll( '.ihpme-wizard-nav' ).forEach( ( wizard, menuIndex ) => {
		wizard.tabIndex = -1;

		const wizardPanelToggles = new WeakMap();
		const wizardBackButtons = new WeakMap();

		let panelCount = 0;
		const allPanels = [];
		function menu2panel( menu, backLabel ) {
			panelCount++;

			const panel = document.createElement( 'div' );
			panel.id = menu.id || `menu-${ menuIndex + 1 }-panel-${ panelCount }`;
			panel.tabIndex = -1;
			panel.classList.add( 'ihpme-wizard-nav__panel' );
			panel.setAttribute( 'role', 'navigation' );
			panel.setAttribute( 'aria-hidden', true );

			const classes = [ ...menu.classList ];
			panel.classList.add( ...classes.filter( className => className !== 'sub-menu' ) );

			menu.classList.add( 'ihpme-wizard-nav__menu' );
			menu.removeAttribute( 'id' );
			panel.append( menu );
			wizard.append( panel );
			allPanels.push( panel );

			// Loop through items for those with submenus
			[ ...menu.children ].forEach( item => {
				if ( ! item.classList.contains( 'menu-item-has-children' ) ) {
					return;
				}

				// First of each should be direct decendents
				let toggle = item.querySelector( '.menu-item-label, .menu-item-link' );
				const label = toggle.textContent;
				const submenu = item.querySelector( '.sub-menu' );

				// Setup panel for the submenu, have it link back to here
				const subPanel = menu2panel( submenu, `Back to ${ label }` ); // textContent since it's currently hidden

				// Add heading
				const heading = document.createElement( 'h2' );
				heading.classList.add( 'ihpme-wizard-nav__heading' );
				heading.innerText = label;

				if ( toggle.classList.contains( 'menu-item-link' ) ) {
					const link = toggle;
					link.textContent = link.title || `${ label } Overview`;
					link.removeAttribute( 'title' );

					if ( item.classList.contains( 'header-button' ) ) {
						const buttonWrap = document.createElement( 'span' );
						buttonWrap.classList.add( 'wp-block-button', 'has-color-inverse' );
						link.classList.remove( 'menu-item-link' );
						link.classList.add( 'wp-block-button__link' );
						buttonWrap.append( link );
						heading.append( buttonWrap );
					} else {
						const linkWrap = document.createElement( 'li' );
						linkWrap.classList.add( 'menu-item' );
						linkWrap.append( link );
						submenu.prepend( linkWrap );
					}

					toggle = document.createElement( 'button' );
					toggle.classList.add( 'menu-item-label' );
					toggle.textContent = label;

					item.prepend( toggle );
				}

				toggle.setAttribute( 'aria-controls', subPanel.id );
				subPanel.prepend( heading );

				// Create back button
				const backButton = document.createElement( 'button' );
				backButton.classList.add( 'menu-item-label', 'ihpme-wizard-nav__back', 'js-submenu-close' );
				backButton.innerText = backLabel;

				subPanel.prepend( backButton );

				// Log the toggle the panel goes to
				wizardPanelToggles.set( subPanel, toggle );
				// Log the panel the back button points to
				wizardBackButtons.set( backButton, panel );
			} );

			return panel;
		}

		const mainPanel = menu2panel( wizard.querySelector( '.menu' ), 'Back to Main Menu' );
		mainPanel.setAttribute( 'aria-hidden', false );

		wizard.parentElement.querySelectorAll( '.ihpme-wizard-nav-addon' ).forEach( addon => {
			mainPanel.appendChild( addon );
		} );

		wizard.addEventListener( 'click', event => {
			const toggle = event.target;

			let newPanel;
			// See if it's a submenu toggle
			if ( toggle.hasAttribute( 'aria-controls' ) ) {
				newPanel = determineTarget( toggle );
			} else
			// Or back button
			if ( toggle.classList.contains( 'js-submenu-close' ) ) {
				newPanel = wizardBackButtons.get( toggle );
			}

			if ( ! newPanel ) {
				return;
			}

			// Get the current panel to close
			const currentPanel = allPanels.find( panel => panel.getAttribute( 'aria-hidden' ) === 'false' );

			// Skip if somehow the same panel
			if ( currentPanel === newPanel ) {
				return;
			}

			// Hide current panel, mark toggle if present
			currentPanel.setAttribute( 'aria-hidden', true );
			const currentToggle = wizardPanelToggles.get( currentPanel );
			if ( currentToggle ) {
				currentToggle.setAttribute( 'aria-expanded', false );
			}

			// Show new panel, mark toggle if present
			newPanel.setAttribute( 'aria-hidden', false );
			const newToggle = wizardPanelToggles.get( newPanel );
			if ( newToggle ) {
				newToggle.setAttribute( 'aria-expanded', true );
			}

			setTimeout( () => ( newPanel.querySelector( 'a, button' ) || newPanel ).focus() );
		} );
	} );

	// =========================
	// ! Nav Handling
	// =========================

	$( '.ihpme-flyout' ).on( 'click', function( e ) {
		if ( $( e.target ).hasClass( 'ihpme-flyout' ) ) {
			toggleElement( e.target.id, false );
		}
	} );

	// =========================
	// ! Intersection Observers
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		const headingObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				const link = document.querySelector( `a[href="#${ change.target.id }"]` );
				if ( link ) {
					if ( change.isIntersecting ) {
						link.classList.add( 'is-active-target' );
					} else {
						link.classList.remove( 'is-active-target' );
					}
				}
			} );
		}, {
			rootMargin: `10% 0px 25%`,
		} );

		$( '.ihpme-article' ).find( 'h2[id], h3[id]' ).each( function() {
			headingObserver.observe( this );
		} );

		// =========================
		// ! Sticky Header Observer
		// =========================

		const stickyObserver = new IntersectionObserver( ( [ e ] ) => {
			e.target.classList.toggle( 'is-stickied', e.intersectionRatio < 1 );
		}, {
			threshold: [ 1 ],
			rootMargin: '0% 0% 100% 0%',
		} );

		$( '.js-sticky' ).each( function() {
			stickyObserver.observe( this );
		} );
	}

	// =========================
	// ! Peek-a-boo Nav Handling
	// =========================

	let lastScroll = 0;
	let lastDirection = null;
	let lastPastHeader = null;
	const headerThreshold = () => 170;

	$window.scroll( function() {
		const scroll = $window.scrollTop();
		const direction = scroll >= lastScroll ? 1 : -1;
		const pastHeader = scroll > headerThreshold();

		if ( direction !== lastDirection || pastHeader !== lastPastHeader ) {
			$body.toggleClass( 'animating-sticky-nav--in', direction < 0 && pastHeader );
			$body.toggleClass( 'animating-sticky-nav--out', direction > 0 && pastHeader );
		}

		lastScroll = scroll;
		lastDirection = direction;
		lastPastHeader = pastHeader;
	} );

	// =========================
	// ! Search Flyout
	// =========================

	$( '.js-search' ).each( function() {
		const searchUrl = this.dataset.searchUrl;
		const $container = $( this );
		const $results = $container.find( '.js-search-results' );

		if ( $results.length === 0 ) {
			return;
		}

		const $form = $container.find( '.js-search-form' );
		const $input = $container.find( '.js-search-input' );
		const $suggestions = $container.find( '.js-search-suggestion' );
		const $more = $container.find( '.js-search-more' );
		const $query = $container.find( '.js-search-query' );
		const $noResults = $container.find( '.js-search-no-results' );

		$suggestions.on( 'click', function() {
			$input.val( this.value );
			$form.submit();
		} );

		$form.on( 'submit', function( e ) {
			e.preventDefault();
			$container.addClass( 'loading' );

			$noResults.attr( 'aria-hidden', true );
			$query.text( $input.val() );

			$.ajax( {
				url: searchUrl,
				data: { s: $input.val() },
				success( { url, results } ) {
					$container.addClass( 'has-results' );
					$more.attr( 'href', url );

					$results.empty().append( results );
					$noResults.attr( 'aria-hidden', results.length > 0 );
				},
				error() {
					$more.attr( 'href', null );

					$results.empty();
					$noResults.attr( 'aria-hidden', false );
				},
				complete() {
					$container.removeClass( 'loading' );
					$results.fadeIn();
				},
			} );
		} );
	} );

	// =========================
	// ! Excerpt Handling
	// =========================

	$( document ).on( 'click', '.js-expand', function() {
		const expanded = $( this ).closest( '.is-expandable' ).toggleClass( 'is-expanded' ).hasClass( 'is-expanded' );

		// Swap the text with the cached label
		const label = $( this ).data( 'label' ) || ( expanded ? 'Show less' : 'Show more' );
		$( this ).data( 'label', $( this ).text() );
		$( this ).text( label );
	} );

	// =========================
	// ! Filterable Listing Modules
	// =========================

	setupFilterableListings();

	// =========================
	// ! Directory Module
	// =========================

	setupDirectoryModules();

	// =========================
	// ! Discover Feed Module
	// =========================

	setupDiscoverModules();

	// =========================
	// ! Form Element Stuff
	// =========================

	$( document ).on( 'click', 'select', function() {
		const open = $( this ).toggleClass( 'is-open' ).hasClass( 'is-open' );
		if ( open ) {
			$( this ).one( 'blur', function() {
				$( this ).removeClass( 'is-open' );
			} );
		}
	} );

	setupDatePickers( IHPME.calendarSearch );

	// =========================
	// ! Dropdown
	// =========================

	$( '.gfield:has(.ginput_container_select):not(:has(.has-gforms-enhanced-ui))' ).addClass( 'js-dropdown' );

	setupDropdowns();

	// =========================
	// ! Tooltips
	// =========================

	document.querySelectorAll( '.ihpme-tooltip__frame' ).forEach( tooltip => {
		const bounds = tooltip.getBoundingClientRect();
		if ( bounds.left + bounds.width > window.outerWidth ) {
			tooltip.style.left = `${ window.outerWidth - bounds.left - bounds.width - 20 }px`;
		}
	} );

	// =========================
	// ! Bookmark/Share Links
	// =========================

	setupShareButtons();

	$( 'a.js-clipboard' ).on( 'click', e => e.preventDefault() );

	const hrefClipboard = new CliboardJS( 'a.js-clipboard', {
		text( trigger ) {
			return trigger.getAttribute( 'href' );
		},
	} );

	const clipboardTooltipTimeouts = new WeakMap();
	hrefClipboard.on( 'success', e => {
		clearTimeout( clipboardTooltipTimeouts.get( e.trigger ) );
		$( e.trigger ).addClass( 'js-copied' ).attr( 'aria-label', 'Link copied!' );
		const timeout = setTimeout( () => $( e.trigger ).removeClass( 'js-copied' ), 5000 );
		clipboardTooltipTimeouts.set( e.trigger, timeout );
	} );

	// =========================
	// ! Scroller Button
	// =========================

	function makeScrollerButton( type ) {
		const button = document.createElement( 'div' );
		button.className = `ihpme-scroller__button ${ type }`;
		button.setAttribute( 'aria-hidden', true );
		return button;
	}

	document.querySelectorAll( '.ihpme-scroller' ).forEach( scroller => {
		const inner = scroller.querySelector( '.ihpme-scroller__inner' );
		if ( inner.scrollWidth <= scroller.offsetWidth ) {
			return;
		}

		const nextButton = makeScrollerButton( 'next' );
		const prevButton = makeScrollerButton( 'prev' );
		const buttons = [ nextButton, prevButton ];

		scroller.append( nextButton, prevButton );

		prevButton.hidden = true;
		inner.addEventListener( 'scroll', () => {
			nextButton.hidden = inner.scrollLeft + inner.offsetWidth >= inner.scrollWidth;
			prevButton.hidden = inner.scrollLeft === 0;
		} );

		buttons.forEach( button => {
			button.addEventListener( 'click', () => {
				if ( button.classList.contains( 'next' ) ) {
					inner.scrollBy( {
						left: inner.offsetWidth,
					} );
				} else {
					inner.scrollBy( {
						left: -1 * inner.offsetWidth,
					} );
				}
			} );
		} );
	} );

	document.addEventListener( 'keyup', () => {
		const scroller = document.activeElement?.closest( '.ihpme-scroller__inner' );
		if ( scroller ) {
			document.activeElement.scrollIntoView( {
				block: 'nearest',
				inline: 'nearest',
			} );
		}
	} );

	// =========================
	// ! Skip Link on Widgets
	// =========================

	let skipCount = 0;
	document.querySelectorAll( '.wp-block-media-text__media' ).forEach( wrapper => {
		if ( wrapper.querySelector( 'iframe' ) || wrapper.querySelector( 'script' ) ) {
			const id = 'after-widget-' + ++skipCount;

			const after = document.createElement( 'div' );
			after.id = id;
			wrapper.append( after );

			const skip = document.createElement( 'a' );
			skip.href = '#' + id;
			skip.innerText = `Skip ${ wrapper.dataset.label || 'Widget' }`;
			skip.className = 'screen-reader-text skip-link';
			wrapper.prepend( skip );
		}
	} );

	// =========================
	// ! Google Map Handling
	// =========================

	if ( typeof google !== 'undefined' ) {
		$( '.ihpme-google-map[data-config]' ).each( function() {
			const config = $( this ).data( 'config' );
			const { coords, ...options } = config;

			const map = new google.maps.Map( this, {
				center: coords,
				//styles: mapStyles,
				...options,
			} );

			const marker = new google.maps.Marker( {
				position: map.getCenter(),
			} );

			marker.setMap( map );
		} );
	}
} );
